import "./FontEffectTests.scss";

export default function FontEffectTests() {
  return (
    <div className="bg">
      <div className="stacked__wrapper">
        <h3 className="stacked">R</h3>
      </div>

      <div className="result__wrapper-outer">
        <div className="result__wrapper result__wrapper-w">
          <h3 className="result result-0">W</h3>
          <h3 className="result result-1">W</h3>
          <h3 className="result result-2">W</h3>
          <h3 className="result result-3">W</h3>
        </div>
        <div className="result__wrapper result__wrapper-i">
          <h3 className="result result-0">I</h3>
          <h3 className="result result-1">I</h3>
          <h3 className="result result-2">I</h3>
          <h3 className="result result-3">I</h3>
        </div>
        <div className="result__wrapper result__wrapper-n1">
          <h3 className="result result-0">N</h3>
          <h3 className="result result-1">N</h3>
          <h3 className="result result-2">N</h3>
          <h3 className="result result-3">N</h3>
        </div>
        <div className="result__wrapper result__wrapper-n2">
          <h3 className="result result-0">N</h3>
          <h3 className="result result-1">N</h3>
          <h3 className="result result-2">N</h3>
          <h3 className="result result-3">N</h3>
        </div>
        <div className="result__wrapper result__wrapper-e">
          <h3 className="result result-0">E</h3>
          <h3 className="result result-1">E</h3>
          <h3 className="result result-2">E</h3>
          <h3 className="result result-3">E</h3>
        </div>
        <div className="result__wrapper result__wrapper-r">
          <h3 className="result result-0">R</h3>
          <h3 className="result result-1">R</h3>
          <h3 className="result result-2">R</h3>
          <h3 className="result result-3">R</h3>
        </div>
      </div>
    </div>
  );
}
